module.exports = __webpack_public_path__ + "static/img/MANCHESTER_PAINT.cad534a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/MANCHESTER_PAINT.jpg
// module id = MMSx
// module chunks = 0